import { render, staticRenderFns } from "./NormalCompleted.vue?vue&type=template&id=355b595a&scoped=true"
import script from "./NormalCompleted.vue?vue&type=script&lang=ts"
export * from "./NormalCompleted.vue?vue&type=script&lang=ts"
import style0 from "./NormalCompleted.vue?vue&type=style&index=0&id=355b595a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355b595a",
  null
  
)

export default component.exports